import { create } from 'zustand';

interface UIStore {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (isOpen: boolean) => void;
  isLocked: boolean;
  setLocked: (locked: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  // Desktop: open by default. Mobile/tablet: closed so POS content is not covered.
  isSidebarOpen: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (isOpen: boolean) => set({ isSidebarOpen: isOpen }),
  isLocked: typeof window !== 'undefined' && localStorage.getItem('pos_screen_locked') === 'true',
  setLocked: (locked: boolean) => {
    if (locked) {
      localStorage.setItem('pos_screen_locked', 'true');
    } else {
      localStorage.removeItem('pos_screen_locked');
    }
    set({ isLocked: locked });
  },
}));
